import React from 'react';
import {Link} from "react-router-dom";


const DashboardAssistant = () => {
    return (
        <div>
            <h6>
                اینجا داشبورد دستیار می باشد.
                به دستیار حسابدار خوش آمدید.
                <Link to={"/Dashboard"} > برو به داشبورد. اصلی روان حساب </Link>

                <br/><br/><br/>

                <Link className={"btn btn-primary"} to={"/assistant/category/20/21/22"} > برو به یه دسته بندی  .</Link>
                <br/><br/><br/>
                <Link className={"btn btn-primary"} to={"/assistant/report"} > برو به افزودن گزارش.</Link>
                <Link className={"btn btn-primary"} to={"/assistant/report/4"} > برو ب گزارش شماره چهارم مثلا.</Link>
                <br/><br/><br/>
                <div className={""}>
                    <br/><br/><br/>
                    <Link className={"btn btn-primary"} to={"/assistant/new-form"}> برو به افزودن اصلیمون که هم فرم ثابت داره و هم فرم ساز .</Link>
                    <br/><br/><br/>
                    <Link className={"btn btn-primary"} to={"/assistant/bill"}> برو به صورتحساب  .</Link>
                    <br/><br/><br/>
                    <Link className={"btn btn-primary"} to={"/assistant/dashboardAssistant"}> برو به داشبورد دستیار  .</Link>
                    <br/><br/><br/>
                    <Link className={"btn btn-primary"} to={"/assistant/document-form"}> برو به افزودن فرم ساز document-form.</Link>
                    <br/><br/><br/>
                    <Link className={"btn btn-primary"} to={"/assistant/level-form"}> برو به فرم ساز سطح</Link>
                    <br/><br/><br/>
                </div>






            </h6>
        </div>
    );
};

export default DashboardAssistant;
